import Vue from 'vue'
import Vuex from 'vuex'

import orders from './modules/orders'
import statuses from './modules/statuses'
import products from './modules/products'
import authentication from './modules/authentication'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    orders,
    statuses,
    products,
    authentication
  },
  strict: debug,
})
